import React from "react";
import { Loader2 } from "lucide-react";

const LoadingScreen = ({ message }) => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] p-8 text-center">
    <div className="w-14 h-14 rounded-2xl bg-purple-600/20 border border-purple-500/30 flex items-center justify-center text-purple-400 animate-spin mb-4 shadow-purple-glow">
      <Loader2 size={32} />
    </div>
    <span className="text-sm font-semibold text-gray-300 tracking-wide">
      {message || "Carregando dados..."}
    </span>
  </div>
);

export default LoadingScreen;
